import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormContractKeys } from './types'

interface Schema {
    id: FormContractKeys
}

export const FormContract: {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'chassi',
            label: 'Chassi',
            required: true,
            onKeyUp: () => ({})
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    },
    {
        select: {
            id: 'uf',
            label: 'UF',
            required: true,
            isSearching: true,
            optionsType: 'ufContract',
            onChange: () => ({})
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    }
]
